import React from 'react';

const HeaderSettingsIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="20" fill="#F2F8FD" />
      <path
        d="M28.1 17.2199C26.29 17.2199 25.55 15.9399 26.45 14.3699C26.97 13.4599 26.66 12.2999 25.75 11.7799L24.02 10.7899C23.23 10.3199 22.21 10.5999 21.74 11.3899L21.63 11.5799C20.73 13.1499 19.25 13.1499 18.34 11.5799L18.23 11.3899C17.78 10.5999 16.76 10.3199 15.97 10.7899L14.24 11.7799C13.33 12.2999 13.02 13.4699 13.54 14.3799C14.45 15.9399 13.71 17.2199 11.9 17.2199C10.86 17.2199 10 18.0699 10 19.1199V20.8799C10 21.9199 10.85 22.7799 11.9 22.7799C13.71 22.7799 14.45 24.0599 13.54 25.6299C13.02 26.5399 13.33 27.6999 14.24 28.2199L15.97 29.2099C16.76 29.6799 17.78 29.3999 18.25 28.6099L18.36 28.4199C19.26 26.8499 20.74 26.8499 21.65 28.4199L21.76 28.6099C22.23 29.3999 23.25 29.6799 24.04 29.2099L25.77 28.2199C26.68 27.6999 26.99 26.5299 26.47 25.6299C25.56 24.0599 26.3 22.7799 28.11 22.7799C29.15 22.7799 30.01 21.9299 30.01 20.8799V19.1199C30 18.0799 29.15 17.2199 28.1 17.2199ZM20 23.2499C18.21 23.2499 16.75 21.7899 16.75 19.9999C16.75 18.2099 18.21 16.7499 20 16.7499C21.79 16.7499 23.25 18.2099 23.25 19.9999C23.25 21.7899 21.79 23.2499 20 23.2499Z"
        fill="#333333"
      />
    </svg>
  );
};

export default HeaderSettingsIcon;
